const Setup = (() => {
  let setupContainerEle;
  let setupAreaWrapEle;
  let spinner;

  // modules/sections
  const CASE_NOTES = 'Case Notes';
  const DAY_SERVICES = 'Day Services';
  const GENERAL = 'General';
  const INCIDENT_TRACKING = 'Incident Tracking';
  const LOGIN_LOGOUT = 'Login / Logout';
  const PLAN = 'Plan';
  const ROSTER = 'Roster';
  const SCHEDULING = 'Scheduling';
  const TIME_ENTRY = 'Time Entry';
  const TRANSPORTATION = 'Transportation';
  const WORKSHOP = 'Workshop';
  const MONEY_MANAGEMENT = 'Money Management';
  const ADMINISTRATION = 'Administration';

  // sub-sections
  const SYS_PREF = 'System Preferences';
  const MESSAGE_SYS_PREF = 'Messaging';
  const WORK_CODES = 'Work Codes';
  const VENDORS = 'Vendors';
  const HOLIDAYS = 'Holidays';
  const DAY_OFF_REASONS = 'Day Off Reasons';

  let DEFAULT_SECTION;
  const DEFAULT_SUBSECTION = MESSAGE_SYS_PREF;

  const ADV_MENU_ITEMS = {
    [ADMINISTRATION]: [MESSAGE_SYS_PREF, 'Vendors'],
    [DAY_SERVICES]: [SYS_PREF],
    [INCIDENT_TRACKING]: [SYS_PREF],
    [LOGIN_LOGOUT]: [SYS_PREF],
    [MONEY_MANAGEMENT]: ['Account Classes', 'Payees', 'Transaction Categories / Subcategories'],
    [PLAN]: [SYS_PREF],
    [ROSTER]: [SYS_PREF],
    [SCHEDULING]: [DAY_OFF_REASONS, HOLIDAYS, SYS_PREF],
    [TIME_ENTRY]: [SYS_PREF, WORK_CODES],
    [TRANSPORTATION]: [SYS_PREF],
    [WORKSHOP]: [SYS_PREF],
  };
  const GK_MENU_ITEMS = {
    [ADMINISTRATION]: [MESSAGE_SYS_PREF],
    [CASE_NOTES]: [SYS_PREF],
    [GENERAL]: [SYS_PREF],
    [LOGIN_LOGOUT]: [SYS_PREF],
    [PLAN]: [SYS_PREF],
    [ROSTER]: [SYS_PREF],
  };

  function loadView(module, section) {
    if (section === SYS_PREF || section === MESSAGE_SYS_PREF) {
      const newView = SystemPreferences.getView(module);
      setupAreaWrapEle.innerHTML = '';
      setupAreaWrapEle.append(newView);
      return;
    }

    if (module === MONEY_MANAGEMENT) {
      const newView = SetupMoneyManagement.getView(section);
      setupAreaWrapEle.innerHTML = '';
      setupAreaWrapEle.append(newView);
      return;
    }
    if (module === ADMINISTRATION) {
      Vendors.getView().then((newView) => {
        setupAreaWrapEle.innerHTML = '';
        setupAreaWrapEle.append(newView);
        return;
      });
    }
    if (module === TIME_ENTRY && section == WORK_CODES) {
      const newView = SetupWorkCode.getView(section);
      setupAreaWrapEle.innerHTML = '';
      setupAreaWrapEle.append(newView);
      return;
    }
    if (module === SCHEDULING) {
      if (section === HOLIDAYS) {
        Holidays.getView().then((newView) => {
          setupAreaWrapEle.innerHTML = '';
          setupAreaWrapEle.append(newView);
          return;
        });
      }
      if (section === DAY_OFF_REASONS) {
        Setupscheduling.getView(section).then((newView) => {
          setupAreaWrapEle.innerHTML = '';
          setupAreaWrapEle.append(newView);
          return;
        });
      }
    }
  }
  function handleMenuClick(e) {
    const target = e.target;

    const module = target.dataset.module;
    const section = target.dataset.section;

    if (!module || !section) return;

    const activeLink = document.querySelector('.setupMenu__subSection.active');
    if (activeLink) activeLink.classList.remove('active');

    target.classList.add('active');

    loadView(module, section);
  }

  function loadPage() {
    let activeMenuItems;
    if ($.session.applicationName === 'Advisor') {
      activeMenuItems = ADV_MENU_ITEMS;
    } else {
      activeMenuItems = GK_MENU_ITEMS;
    }

    const setupMenuEle = document.createElement('div');
    setupMenuEle.classList.add('setupMenu');
    Object.entries(activeMenuItems).forEach(([sectionTitle, subSectionTitles]) => {
      const menuGroupEle = document.createElement('div');
      menuGroupEle.classList.add('setupMenu__group');
      setupMenuEle.appendChild(menuGroupEle);

      const sectionEle = document.createElement('p');
      sectionEle.classList.add('setupMenu__section');
      sectionEle.textContent = sectionTitle;
      menuGroupEle.appendChild(sectionEle);

      subSectionTitles.forEach(subSectionTitle => {
        const subSectionEle = document.createElement('p');
        subSectionEle.classList.add('setupMenu__subSection');
        subSectionEle.textContent = subSectionTitle;
        subSectionEle.setAttribute('data-module', sectionTitle);
        subSectionEle.setAttribute('data-section', subSectionTitle);

        menuGroupEle.appendChild(subSectionEle);

        if (DEFAULT_SECTION === sectionTitle && DEFAULT_SUBSECTION === subSectionTitle) {
          subSectionEle.classList.add('active');
        }
      });
    });

    setupAreaWrapEle = document.createElement('div');
    setupAreaWrapEle.classList.add('setupArea');

    setupMenuEle.addEventListener('click', handleMenuClick);

    setupContainerEle.appendChild(setupMenuEle);
    setupContainerEle.appendChild(setupAreaWrapEle);
  }

  async function loadData() {
    try {
      if ($.session.applicationName === 'Advisor') {
        const [setupDataResp, mmDropdownDataResp, categoryDataResp, subCategoryDataResp] = await Promise.all([
          _UTIL.fetchData('getSetupPageData', { userId: $.session.UserId }),
          _UTIL.fetchData('getSetupPageDropdownData'),
          _UTIL.fetchData('getTransactionCategories', { token: $.session.Token, userId: $.session.UserId }),
          _UTIL.fetchData('getTransactionSubcategories', { token: $.session.Token, userId: $.session.UserId })
        ]);

        SystemPreferences.init(setupDataResp.GetSetupPageDataResult.systemPrefereces);
        SetupMoneyManagement.init(
          setupDataResp.GetSetupPageDataResult.moneyManagement,
          mmDropdownDataResp.GetSetupPageDropdownDataResult,
          categoryDataResp.getTransactionCategoriesResult,
          subCategoryDataResp.getTransactionSubcategoriesResult
        );
        await SetupWorkCode.init();
      } else {
        const resp = await _UTIL.fetchData('getAllSystemPreferences', {
          token: $.session.Token,
          userId: $.session.UserId,
        });
        SystemPreferences.init(resp.getAllSystemPreferencesResult);
      }

      DOM.ACTIONCENTER.removeChild(spinner);
      loadPage();
      loadView(DEFAULT_SECTION, DEFAULT_SUBSECTION);
    } catch (error) {
      console.log(error);
    }
  }

  async function init() {
    DOM.clearActionCenter();
    spinner = PROGRESS.SPINNER.get('Loading Setup...');
    DOM.ACTIONCENTER.appendChild(spinner);

    DEFAULT_SECTION = $.session.applicationName === 'Gatekeeper' ? ADMINISTRATION : ADMINISTRATION;

    setupContainerEle = document.createElement('div');
    setupContainerEle.classList.add('setupContainer');

    DOM.ACTIONCENTER.appendChild(setupContainerEle);
    setActiveModuleAttribute('setup');
    _DOM.ACTIONCENTER.setAttribute('data-UI', true);

    loadData();
  }

  return {
    init,
    CASE_NOTES,
    DAY_SERVICES,
    GENERAL,
    INCIDENT_TRACKING,
    LOGIN_LOGOUT,
    PLAN,
    ROSTER,
    SCHEDULING,
    TIME_ENTRY,
    TRANSPORTATION,
    WORKSHOP,
    ADMINISTRATION
  };
})();
